import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase';
import { doc, onSnapshot } from 'firebase/firestore';

export interface BusinessInfo {
  instagram: string;
  facebook: string;
  tiktok: string;
  whatsapp: string; // Phone number without + or spaces for the link
  address: string;
  phone: string; // Formatted phone for display
}

const defaultInfo: BusinessInfo = {
  instagram: 'https://instagram.com/bucara__burger',
  facebook: 'https://www.facebook.com/profile.php?id=61589000696717',
  tiktok: 'https://tiktok.com/@bucara__burger',
  whatsapp: '19862173604',
  address: 'Boise, Idaho 83701',
  phone: '+1 (986) 217-3604',
};

export function useBusinessInfo() {
  const [info, setInfo] = useState<BusinessInfo>(defaultInfo);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'settings', 'business_info'), (docSnap) => {
      if (docSnap.exists()) {
        setInfo(docSnap.data() as BusinessInfo);
      }
      setLoading(false);
    });

    return () => unsub();
  }, []);

  const isFullLink = info.whatsapp?.includes('wa.me') || info.whatsapp?.startsWith('http');
  const waLink = isFullLink 
    ? info.whatsapp 
    : `https://wa.me/${info.whatsapp ? info.whatsapp.replace(/\D/g, '') : ''}?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order.`;

  return { info, loading, waLink };
}
